module.exports = __webpack_public_path__ + "static/media/myWorld.f4f50b0b.svg";